import { useId } from "react";

import { smoothLinePath } from "./chartUtils";
import "./ui.css";

interface SparklineProps {
  values: number[];
  width?: number;
  height?: number;
  className?: string;
}

export function Sparkline({ values, width = 84, height = 22, className = "" }: SparklineProps) {
  const gradId = useId().replace(/[:]/g, "");

  if (!values || values.length < 2) return null;

  const min = Math.min(...values);
  const max = Math.max(...values);
  const range = max - min || 1;
  const step = width / (values.length - 1);
  const points = values.map((v, i) => {
    const x = i * step;
    const y = height - 2 - ((v - min) / range) * (height - 4);
    return [x, y] as const;
  });

  const line = smoothLinePath(points);
  const last = points[points.length - 1];
  const area = `${line} L ${last[0]} ${height} L 0 ${height} Z`;

  return (
    <svg
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      className={`sparkline ${className}`}
      aria-hidden="true"
    >
      <defs>
        <linearGradient id={`spark-grad-${gradId}`} x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor="var(--accent)" stopOpacity="0.28" />
          <stop offset="100%" stopColor="var(--accent)" stopOpacity="0" />
        </linearGradient>
      </defs>
      <path d={area} fill={`url(#spark-grad-${gradId})`} />
      <path d={line} className="sparkline__line" />
      <circle cx={last[0]} cy={last[1]} r="2.5" className="sparkline__dot" />
    </svg>
  );
}
